export default {
	ROOT: '1',
	ADMIN: '2',
	SUPPORT_LEAD: '3',
	SUPPORT: '4',
	SCHOOL_ADMIN: '4',
	USER: '5',
	DISTRICT_ADMIN: '6',
	SUPPORT_OPERATOR: '7',
	SUPPORT_CONTENT: '8',
	SUPPORT_MARKETING: '9',
	SALESFORCE: '10',
	CUSTOM: '11',
}
